var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser4Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V36C42 39.3137 39.3137 42 36 42H6C2.68629 42 0 39.3137 0 36V6Z",
    fill: "#EEEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0424 25.0449C28.8561 25.4148 29.0049 25.8657 29.3748 26.0521C29.7447 26.2385 30.1957 26.0897 30.382 25.7198L29.0424 25.0449ZM16.2805 11.6183C15.9106 11.8047 15.7618 12.2556 15.9482 12.6255C16.1346 12.9954 16.5855 13.1442 16.9554 12.9579L16.2805 11.6183ZM14.6327 14.6396C14.928 14.3491 14.932 13.8743 14.6415 13.5789C14.3511 13.2836 13.8762 13.2797 13.5809 13.5701L14.6327 14.6396ZM28.4267 28.4218C28.7173 28.1266 28.7135 27.6517 28.4183 27.3611C28.1231 27.0706 27.6482 27.0744 27.3577 27.3696L28.4267 28.4218ZM30.382 25.7198C32.4209 21.673 31.6337 16.7749 28.4295 13.5708L27.3689 14.6314C30.1153 17.3778 30.79 21.5762 29.0424 25.0449L30.382 25.7198ZM28.4295 13.5708C25.2254 10.3666 20.3273 9.57945 16.2805 11.6183L16.9554 12.9579C20.4241 11.2103 24.6225 11.885 27.3689 14.6314L28.4295 13.5708ZM13.5809 13.5701C10.8918 16.2147 9.82769 20.0985 10.7933 23.7444L12.2433 23.3604C11.4156 20.2353 12.3277 16.9064 14.6327 14.6396L13.5809 13.5701ZM10.7933 23.7444C11.7588 27.3904 14.6057 30.2384 18.2513 31.2054L18.6359 29.7555C15.5111 28.9267 13.0709 26.4855 12.2433 23.3604L10.7933 23.7444ZM18.2513 31.2054C21.8969 32.1724 25.781 31.1098 28.4267 28.4218L27.3577 27.3696C25.0899 29.6736 21.7607 30.5844 18.6359 29.7555L18.2513 31.2054Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25L30.75 30.75",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser4Bw);
export default __webpack_public_path__ + "static/media/user-4-bw.f8cb8ec7984ac0f78a16bbbaf247d8db.svg";
export { ForwardRef as ReactComponent };